import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { formatNumber } from '../helpers/formatNumber';
import { roundNumber } from '../helpers/roundNumber';


export const EconomicsNPVDataTable = ({ npv, currency }) => {

  const names = npv ? Object.keys(npv)?.filter(n => n !== 'roi' && 
    n !== 'roiATax' && 
    n !== 'irr' && 
    n !== 'irrATax' && 
    n !== 'payout' && 
    n !== 'payoutATax' &&
    n !== 'pi10' &&
    n !== 'pi10ATax' &&
    n !== 'roi' &&
    n !== 'stateIncomeTax'
  ) : [];

  const rows = names?.map(name => {
    return { 
      name, 
      npv0: npv?.[name] ? formatNumber(roundNumber(npv[name][0])) : 0,
      npv5: npv?.[name] ? formatNumber(roundNumber(npv[name][1])) : 0,
      npv10: npv?.[name] ? formatNumber(roundNumber(npv[name][2])) : 0,
      npv15: npv?.[name] ? formatNumber(roundNumber(npv[name][3])) : 0,
      npv20: npv?.[name] ? formatNumber(roundNumber(npv[name][4])) : 0,
      npv25: npv?.[name] ? formatNumber(roundNumber(npv[name][5])) : 0
    };
  });

  return (
    <TableContainer style={{width: '100%'}} >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell style={{fontWeight: 'bold', fontSize: 12}}>Cash Flow</TableCell>
            {['NPV 0%', 'NPV 5%', 'NPV 10%', 'NPV 15%', 'NPV 20%', 'NPV 25%'].map(npv => {
              return <TableCell align="right" style={{fontWeight: 'bold', fontSize: 12}} key={npv}>{npv}</TableCell>
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" style={{fontSize: 12}}>
                {formatRowName(row.name, currency)}
              </TableCell>
              {['npv0', 'npv5', 'npv10', 'npv15', 'npv20', 'npv25'].map(npv => {
                return <TableCell align="right" style={{fontSize: 12}} key={npv}>{row[npv] || 0}</TableCell>
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

function formatRowName(name, currency) {
  switch(name) {
    case 'grossRevenue':
      return `Gross Revenue (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'royalty':
      return `Effective Royalties (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'adValorem':
      return `Ad Valorem Tax (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'netRevenue':
      return `Net Revenue (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'costs':
      return `OPEX (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'capex':
      return `CAPEX (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'abandonment':
      return `Abandonment (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'cashflowBTax':
      return `Cash Flow b/ Tax (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'incomeTax':
      return `Income Tax (${currency === 'cad' ? 'CAD' : 'USD'})`;
    case 'cashflowATax':
      return `Cash Flow a/ Tax (${currency === 'cad' ? 'CAD' : 'USD'})`;
    default:
      return ""
  };
}